<template>
  <AppBar color="primary" dark>
    <template v-slot:left-side>
      <NavigationButtons />

      <router-link to="/manage" class="home-link"><v-toolbar-title>Zarządzanie</v-toolbar-title></router-link>

      <ManageBreadcrumb />
    </template>
    <template v-slot:right-side>
      <AccountBar />
    </template>
  </AppBar>
</template>

<script>
import AppBar from '@/components/shared/AppBar.vue';
import AccountBar from '@/components/shared/AccountBar.vue';
import NavigationButtons from '@/components/shared/NavigationButtons.vue';
import ManageBreadcrumb from '@/components/breadcrumbs/ManageBreadcrumb.vue';

export default {
  components: {
    AppBar,
    AccountBar,
    NavigationButtons,
    ManageBreadcrumb
  }
};
</script>

<style lang="scss" scoped>
.home-link {
  color: white;
  text-decoration: none;
}
</style>
